
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/engage-v2/[client]/agendas",
      function () {
        return require("private-next-pages/engage-v2/[client]/agendas.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/engage-v2/[client]/agendas"])
      });
    }
  